import React from 'react';
import { useNavigate } from 'react-router-dom';
import { quickActionFor } from '../../utils/quickActions';

/*
 * Os botões de ação rápida do balcão, iguais na Operação e na Receção (era aí que estavam os sete botões sem onClick).
 * Cada ação tem um destino: um ecrã (`to` → navega) ou um diálogo desta página (`dialog` → chama `onDialog`, para
 * funcionar tanto com o módulo Receção ligado como desligado). Sem destino, o botão aparece desativado e diz porquê
 * (title), para o controlo nunca mentir. `styles` vem da página para manter o aspeto que já existia.
 */
export default function QuickActions({ actions = [], onDialog, style, buttonStyle, disabledStyle }) {
  const navigate = useNavigate();
  if (!Array.isArray(actions) || actions.length === 0) return null;

  return (
    <div style={style}>
      {actions.map((key) => {
        const action = quickActionFor(key);
        const available = Boolean(action.to || (action.dialog && onDialog));
        const run = () => {
          if (action.to) navigate(action.to);
          else if (action.dialog && onDialog) onDialog(action.dialog);
        };
        return (
          <button
            key={key}
            type="button"
            style={available ? buttonStyle : { ...buttonStyle, ...(disabledStyle || {}), cursor: 'not-allowed', opacity: 0.55 }}
            disabled={!available}
            title={available ? action.label.replace('＋ ', '') : action.why}
            aria-disabled={!available}
            onClick={available ? run : undefined}
          >
            {action.label}
          </button>
        );
      })}
    </div>
  );
}
